import { PropsWithChildren } from 'react'
import { Box, IconWarningAmber, Text } from '@machobear/design-system'

interface Props extends PropsWithChildren {
  title: string
}

export const Banner = ({ title, children }: Props) => (
  <Box
    display="flex"
    flexDirection="row"
    alignItems="flexStart"
    gap="xxsmall"
    padding="small"
    background="cautionLight"
    border="borderNeutralLight"
    borderRadius="large"
    style={{ borderColor: '#FEE384' }}
  >
    <Box>
      <IconWarningAmber tone="caution" size="small" />
    </Box>

    <Box
      display="flex"
      flexDirection="column"
      gap="xsmall"
      style={{ paddingTop: '2px', paddingBottom: '2px' }}
    >
      <Text tone="caution" weight="strong" size="standard">
        {title}
      </Text>
      {children}
    </Box>
  </Box>
)
